<template lang="html">
  <v-container>
    <v-row>
      <v-col xs12 md8 v-if="$store.state.User.recent_invited_user.length === 0">
        <v-card>
          <h1>No user invites here...</h1>
        </v-card>
      </v-col>
      <v-col xs12 md8 v-if="$store.state.User.recent_invited_user.length > 0">
        <v-data-table
          :headers="headers"
          :items="$store.state.User.recent_invited_user"
          :sort-by="[]"
          :sort-desc="[false, true]"
          single-select
          multi-sort
          class="elevation-1"
        >
        <template v-slot:item.copy="{ item }">
          <v-tooltip
            :open-on-hover="false"
            bottom
          >
            <template #activator="{ on }">
              <v-icon
                medium
                class="mr-2"
                :disabled="!hasPermission('User READ ALL')"
                @click="on.click"
                @blur="on.blur"
                @click.native="copyEmail(item.email)"
              >
                content_copy
              </v-icon>
            </template>
            <span>Email copied to clipboard</span>
          </v-tooltip>
        </template>
          <template v-slot:item.actions="{ item }">
            <StandardDialog v-if="show_dialog" @click-outside="show_dialog=false">
              <template #content>
                <StandardTextCard
                  height="74vh"
                  :name="'Deactivate User'"
                  :clickable="false"
                >
                  <template #info>
                    <h2>{{item.first_name}} {{item.last_name}}</h2>
                    <h3>{{item.email}}</h3>
                  </template>
                  <template #actions>
                    <v-btn color="red" text @click="deactivateUser({
                      id: item.id,
                    })">Deactivate user</v-btn>
                    <v-btn color="grey" text @click="show_dialog=false">Cancel</v-btn>
                  </template>
                </StandardTextCard>
              </template>
            </StandardDialog>
            <v-icon
              medium
              class="mr-2"
              :disabled="!hasPermission('User READ ALL')"
              @click="show_dialog = true"
            >
              no_accounts
            </v-icon>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import StandardDialog from '@/components/StandardComponents/StandardDialog.component.vue';
import StandardTextCard from '@/components/StandardComponents/StandardTextCard.component.vue';
import { mapActions, mapGetters } from 'vuex';
import store from '@/store/index';
export default {
  name: 'UserInvites',
  components: { StandardDialog, StandardTextCard },
  beforeRouteEnter (to, from, next) {
    store.dispatch('User/requestRecentInvitedUser').then(res => next(res));
  },
  data: function () {
    return {
      show_dialog: false,
      headers: [
        { text: 'ID', value: 'id' },
        { text: 'Email', value: 'email' },
        { text: 'Copy Email to Clipboard', value: 'copy' },
        { text: 'First name', value: 'first_name' },
        { text: 'Last name', value: 'last_name' },
        { text: 'Created', value: 'created' },
        { text: 'Last Active', value: 'updated' },
        { text: 'Actions', value: 'actions', sortable: false }
      ]
    }
  },
  computed: {
    // ...mapGetters('User', [
    //   'requestRecentInvitedUser'
    // ]),
    ...mapGetters('Auth', [
      'hasPermission'
    ])
  },
  methods: {
    ...mapActions('User', [
      'deactivateUser'
    ]),
    copyEmail(email){
      navigator.clipboard.writeText(email);
    }
  }
}
</script>

<style lang="css" scoped>
</style>
